import React from 'react';
import { Link } from 'react-navi';
import styled from 'styled-components';
import '../css/oasislogolink.css'
import logo from 'bakerdao/images/BKRlogo.png'

import useLanguage from 'hooks/useLanguage';

const StyledLink = styled(Link)`
  font-size: 22px;
  line-height: 26px;
  font-weight: bold;
`;


const Logo = (props) => {
  const { lang } = useLanguage();
  return (
    <StyledLink {...props} href="" className="baker-logo-contain">
      <img className="baker-logo" src={logo}></img>
      <span>{lang.app_name}</span>
    </StyledLink>
  )
}

export default styled(Logo)``;
